import { render, staticRenderFns } from "./testDataList.vue?vue&type=template&id=4ca3e6ae"
import script from "./testDataList.vue?vue&type=script&lang=js"
export * from "./testDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports